import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { LandingV2 } from './pages/LandingV2';
import { LandingV3 } from './pages/LandingV3';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        {/* /v2 → always LandingV2, direct access */}
        <Route path="/v2" element={<LandingV2 data-id="element-5" />} data-id="element-4" />
        {/* /v3 → always LandingV3, direct access */}
        <Route path="/v3" element={<LandingV3 data-id="element-7" />} data-id="element-6" />
        {/* / → split test V1 vs V3 (controlled by index.tsx) */}
        <Route path="/*" element={<App data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}